import { Suspense } from 'react'

import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import { PrimeReactProvider } from 'primereact/api'

import AuthLayout    from './Components/Layouts/AuthLayout'
import BackLayout    from './Components/Layouts/BackLayout'

import NotFoundPage from './Components/Errors/Pages/NotFoundPage'
import RouterError  from './Components/Errors/RouterError'

import ActualitesLoader from './Components/Loaders/ActualitesLoader'
import PersonNameLoader from './Components/Loaders/PersonNameLoader'
import ArticleLoader    from './Components/Loaders/ArticleLoader'
import LayoutLoader     from './Components/Loaders/LayoutLoader'

import RootSpinner from './Components/Spinners/RootSpinner'

import AppVersion from './Components/Configs/AppVersion'

import ROUTES from './routes'
import FrontLayout from './Components/Layouts/FrontLayout'

const prime_params = { ripple: true, unstyled: true };

const routes =
[
	{
		path: '*',
		errorElement: RouterError,
		element: <NotFoundPage error="Cette page n'existe pas." center />
	},

	{
		path: '/',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: '',
				lazy: ROUTES.HomePage
			},
			{
				path: 'a-propos',
				lazy: ROUTES.AboutPage
			},
			{
				path: 'contrats-obseques',
				lazy: ROUTES.PrevoyancePage
			},
			{
				path: 'contact',
				lazy: ROUTES.ContactPage
			},
			{
				path: 'avis-de-deces',
				lazy: ROUTES.EnterrementsPage
			},
			{
				path: 'actualites',
				lazy: ROUTES.ActualitesPage,
				loader: ActualitesLoader
			},
			{
				path: 'actualites/:slug',
				lazy: ROUTES.ArticlePage,
				loader: ArticleLoader
			},
			{
				path: 'avis-de-deces/faire-une-condoleance/:id',
				lazy: ROUTES.CondoleanceFormPage,
				loader: PersonNameLoader
			}
		]
	},

	{
		path: '/obseques',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: '',
				lazy: ROUTES.ObsequesPage
			},
			{
				path: 'urgence-deces',
				lazy: ROUTES.UrgenceDecesPage
			},
			{
				path: 'cremation',
				lazy: ROUTES.CremationPage
			},
			{
				path: 'inhumation',
				lazy: ROUTES.InhumationPage
			},
			{
				path: 'devis-obseques',
				lazy: ROUTES.DevisObsequesPage
			},
			{
				path: 'inhumation-ou-cremation',
				lazy: ROUTES.IOCPage
			},
			{
				path: 'etapes-organisation-obseques',
				lazy: ROUTES.EtapesOrganisationPage
			},
			{
				path: 'types-ceremonie',
				lazy: ROUTES.TypesCeremoniePage
			}
		]
	},

	{
		path: '/fleurs-et-plaques',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: 'commande-fleurissement',
				lazy: ROUTES.CommandeFleurissementPage
			},
			{
				path: 'livrer-des-fleurs',
				lazy: ROUTES.LivrerDesFleursPage
			},
			{
				path: 'catalogue-plaques',
				lazy: ROUTES.CataloguePlaquesPage
			},
			{
				path: 'catalogue-fleurs',
				lazy: ROUTES.CatalogueFleursPage
			}
		]
	},

	{
		path: '/marbrerie',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: '',
				lazy: ROUTES.MarbreriePage
			},
			{
				path: 'choisir-un-monument',
				lazy: ROUTES.ChoisirMonumentPage
			},
			{
				path: 'choisir-un-caveau',
				lazy: ROUTES.ChoisirCaveauPage
			},
			{
				path: 'configurer-monument',
				lazy: ROUTES.ConfigurerMonumentPage
			},
			{
				path: 'entretenir-un-monument',
				lazy: ROUTES.EntretenirMonumentPage
			},
			{
				path: 'commander-un-nettoyage',
				lazy: ROUTES.CommanderNettoyagePage
			},
			{
				path: 'quelle-couleur-de-granit-choisir',
				lazy: ROUTES.CouleursGranitPage
			},
			{
				path: 'renover-une-sepulture',
				lazy: ROUTES.RenoverSepulturePage
			},
			{
				path: 'devis',
				lazy: ROUTES.MarbrerieDevisPage
			}			
		]
	},

	{
		path: '/assurance-obseques',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: '',
				lazy: ROUTES.AssuranceObsequesPage
			},
			{
				path: 'obtenir-un-devis',
				lazy: ROUTES.ObtenirDevisPage
			},
			{
				path: 'nos-deux-contrats',
				lazy: ROUTES.NosDeuxContratsPage
			}
			,
			{
				path: 'comprendre-un-devis',
				lazy: ROUTES.ComprendreUnDevisPage
			},
			{
				path: 'conseils',
				lazy: ROUTES.ConseilsPage

			},
			{
				path: 'preparer-ses-obseques',
				lazy: ROUTES.PreparerObsequesPage

			},
			{
				path: 'devis',
				lazy: ROUTES.AssuranceDevisPage
			}
		]
	},

	{
		path: '/',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <AuthLayout />,

		children:
		[
			{
				path: 'login',
				lazy: ROUTES.LoginPage
			},
			{
				path: 'mot-de-passe-oublie',
				lazy: ROUTES.RequestPasswordPage
			},
			{
				path: 'mot-de-passe-oublie/nouveau-mot-de-passe/:token',
				lazy: ROUTES.NewPasswordPage
			}
		]
	},

	{
		path: 'mon-compte',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <BackLayout />,

		children:
		[
			{
				path: '',
				lazy: ROUTES.MyAccountPage
			}
		]
	},

	{
		path: '/admin',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <BackLayout />,

		children:
		[
			{
				path: 'accueil',
				lazy: ROUTES.AdminHomePage
			},
			{
				path: 'liste-des-utilisateurs',
				lazy: ROUTES.UsersListPage
			},
			{
				path: 'liste-des-utilisateurs/nouvel-utilisateur',
				lazy: ROUTES.NewUserPage
			},
			{
				path: 'liste-des-utilisateurs/:user_id',
				lazy: ROUTES.UserPage
			},
			{
				path: 'liste-des-actualites',
				lazy: ROUTES.NewsListPage
			},
			{
				path: 'liste-des-actualites/nouvelle',
				lazy: ROUTES.NewNewsPage
			},
			{
				path: 'liste-des-actualites/:news_id',
				lazy: ROUTES.UpdateNewsPage
			},
			{
				path: 'liste-des-condoleances',
				lazy: ROUTES.CondoleanceListPage
			},
			{
				path: 'liste-des-condoleances/:condoleance_id',
				lazy: ROUTES.CondoleancePage
			},
			{
				path: 'liste-des-enterrements',
				lazy: ROUTES.EnterrementListPage
			},
			{
				path: 'liste-des-enterrements/nouvel-enterrement',
				lazy: ROUTES.NewEnterrementPage
			},
			{
				path: 'liste-des-enterrements/:enterrement_id',
				lazy: ROUTES.EnterrementPage
			},
			{
				path: 'liste-des-avis',
				lazy: ROUTES.AvisListPage
			},
			{
				path: 'liste-des-avis/nouvel-avis',
				lazy: ROUTES.NewAvisPage
			},
			{
				path: 'liste-des-avis/:avis_id',
				lazy: ROUTES.AvisPage
			}
		]
	}
];

const react_router_future =
{
	v7_startTransition: true,
	v7_relativeSplatPath: true,
	v7_fetcherPersist: true,
	v7_skipActionErrorRevalidation: true
};

const router = createBrowserRouter(routes,
{
	future: react_router_future
});

export default function App ()
{
	return (
		<PrimeReactProvider value={ prime_params }>

			<Suspense fallback={ <RootSpinner active /> }>
				<RouterProvider router={ router } future={ react_router_future } />
			</Suspense>

			<AppVersion />

		</PrimeReactProvider>
	);
}